/**
 * Compare a live form snapshot to the last loaded values.
 * Persist-edit save buttons stay disabled until this returns true.
 */
export function formSnapshotDirty(current: unknown, baseline: unknown): boolean {
  return JSON.stringify(current) !== JSON.stringify(baseline);
}
